module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAASxJREFUeNrs3NEJwjAUQNFEHKCjdIQ6kpM4Uh2ho7hBrOC3H08SQnLOf6l9XKkQeSkBAAAAAAAAVFdK2UvM7rPGXGQ3NwEIAAEgAASAABAAAkAACAABIAAEgAAQAAJAAAgAATCMa/TCSn9uXCeY+VpjdjnnW9MATpvvT8jS0+y8AvwGQAAIAAEgAASAABAAAkAACICx/XMY9OzoOY5J7gkAAAAAAAAAAAAAAAAATC5HL6y0KjbqyDnfW97wfP5H6mi1rVWx7a0jzMB+gMkJQAAIAAEgAASAABAAAkAACIDh9bYq9nPAsgw+81fqaM1sOIDo8eMv3yPmbfAAjhqz8wpAAAgAASAABIAAEAACQAAIAAEgAASAABAAAkAACEAARgAAAAAAAAAworcAAwBELpPy+cUXxwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/icons/videoplayer/fullscreen-leave-128x128-white.png
// module id = E+Z8
// module chunks = 1